import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register, error } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", cohort_year: "", agency: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await register({
      ...form,
      cohort_year: form.cohort_year ? parseInt(form.cohort_year) : null,
    });
    setBusy(false);
    if (ok) navigate("/feed");
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 lg:p-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <div>
            <div className="label-eyebrow">Join the Association</div>
            <h1 className="mt-2 font-display text-4xl text-[#0A192F]">Create your member account</h1>
            <p className="mt-2 text-sm text-slate-600">Open exclusively to current and former Presidential Management Fellows.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="name">Full name</Label>
            <Input id="name" value={form.name} onChange={set("name")} required data-testid="register-name-input" className="h-11" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">PMF email</Label>
            <Input id="email" type="email" value={form.email} onChange={set("email")} required data-testid="register-email-input" className="h-11" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={form.password} onChange={set("password")} required minLength={6} data-testid="register-password-input" className="h-11" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label htmlFor="cohort">Cohort year</Label>
              <Input id="cohort" type="number" value={form.cohort_year} onChange={set("cohort_year")} placeholder="2018" data-testid="register-cohort-input" className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="agency">Agency</Label>
              <Input id="agency" value={form.agency} onChange={set("agency")} placeholder="Dept. of State" data-testid="register-agency-input" className="h-11" />
            </div>
          </div>
          {error && <div className="text-sm text-[#9B111E]" data-testid="register-error">{error}</div>}
          <Button type="submit" disabled={busy} data-testid="register-submit-button" className="w-full bg-[#002855] hover:bg-[#0A192F] text-white h-11 rounded-md">{busy ? "Creating…" : "Create account"}</Button>
          <div className="text-sm text-slate-600">Already a member? <Link to="/login" className="text-[#002855] font-medium hover:text-[#C5A059]">Sign in →</Link></div>
        </form>
      </div>
      <div className="relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIweW91bmclMjBwcm9mZXNzaW9uYWxzJTIwb2ZmaWNlfGVufDB8fHx8MTc4MjY2MzI4MXww&ixlib=rb-4.1.0&q=85" className="absolute inset-0 w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-[#0A192F]/65" />
        <div className="relative h-full flex flex-col justify-end p-12 text-[#FDFBF7]">
          <div className="label-eyebrow text-[#C5A059]">Members only</div>
          <h2 className="mt-3 font-display text-5xl leading-tight">A community as committed as you are.</h2>
        </div>
      </div>
    </div>
  );
}
